export default __webpack_public_path__ + "static/media/PPI-patio-031.3d6991bf.jpg";